import { createSlice } from '@reduxjs/toolkit';

interface InitialState {
  project?: any;
  savedTrigger: number;
  closeTrigger: number;
  removedRequestTrigger: number;
  updatedSubtaskTrigger: number;
  deletedTrigger: number;
}

const initialState: InitialState = {
  project: undefined,
  savedTrigger: 0,
  closeTrigger: 0,
  removedRequestTrigger: 0,
  updatedSubtaskTrigger: 0,
  deletedTrigger: 0,
};

export const globalTaskModalSlice = createSlice({
  name: 'globalTaskModal',
  initialState,
  reducers: {
    setGlobalTaskModal: (
      state,
      {
        payload,
      }: {
        payload: {
          project?: any;
        };
        type: string;
      },
    ) => ({
      ...state,
      project: payload.project,
    }),
    setGlobalTaskModalSavedTrigger: (state) => ({ ...state, savedTrigger: state.savedTrigger + 1 }),
    setGlobalTaskModalClosedTrigger: (state) => ({ ...state, closeTrigger: state.closeTrigger + 1 }),
    setGlobalTaskModalRemovedRequestTrigger: (state) => ({ ...state, removedRequestTrigger: state.removedRequestTrigger + 1 }),
    setGlobalTaskModalUpdatedSubtaskTrigger: (state) => ({ ...state, updatedSubtaskTrigger: state.updatedSubtaskTrigger + 1 }),
    setGlobalTaskModalDeletedTrigger: (state) => ({ ...state, deletedTrigger: state.deletedTrigger + 1 }),
  },
});

export const {
  setGlobalTaskModal,
  setGlobalTaskModalSavedTrigger,
  setGlobalTaskModalClosedTrigger,
  setGlobalTaskModalRemovedRequestTrigger,
  setGlobalTaskModalUpdatedSubtaskTrigger,
  setGlobalTaskModalDeletedTrigger,
} = globalTaskModalSlice.actions;

export default globalTaskModalSlice.reducer;
